import Ajv from 'ajv';

// strict: false — allow user-authored schemas that use draft-07 extras like `format` keywords
// without AJV rejecting them as unknown.
const ajv = new Ajv({ strict: false });

export interface JsonSchemaValidationResult {
  ok: boolean;
  message?: string;
}

export function validateJsonSchemaString(value: string): JsonSchemaValidationResult {
  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    return { ok: false, message: 'Must be valid JSON' };
  }

  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
    return { ok: false, message: 'Must be a JSON object' };
  }

  try {
    ajv.compile(parsed);
  } catch (err) {
    const detail = err instanceof Error ? err.message : 'invalid schema';
    return { ok: false, message: `Not a valid JSON Schema: ${detail}` };
  }

  // Narrow to the Anthropic-accepted shape for Output.object: root must be type:"object".
  // AJV's meta-schema accepts type:"string" etc., but that produces nothing usable at
  // interview-processing time.
  const schema = parsed as Record<string, unknown>;
  if (schema.type !== 'object') {
    return { ok: false, message: 'Root must have `type: "object"`' };
  }

  return { ok: true };
}
